// IMPORT REACT
import React from 'react';

import YAButton from '../Button';

// IMPORT IMAGES/STYLES
import { SC_FormGroup, SC_FormLink } from '../styles';


const YAFormLink = (props) => {
    return (
        <SC_FormGroup>
            <YAButton {...props}>{props.children}</YAButton>
        </SC_FormGroup>
    )

}
export default YAFormLink;